//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteBlockTextAndMediaImageDisplayItem } from './WebsiteBlockTextAndMediaImageDisplayItem';
import { WebsiteBlockTextAndMediaActionDisplayItem } from './WebsiteBlockTextAndMediaActionDisplayItem';
import { WebsiteBlockDisplayItem } from './WebsiteBlockDisplayItem';
import { WebsiteBlockTextAndMediaType, WebsiteBlockType } from './Enums';

export class WebsiteBlockTextAndMediaDisplayItem extends WebsiteBlockDisplayItem {
    Header: string | null = null;
    Body: string | null = null;
    Images: WebsiteBlockTextAndMediaImageDisplayItem[] = [];
    Action: WebsiteBlockTextAndMediaActionDisplayItem | null = null;
    TextAndMediaType: WebsiteBlockTextAndMediaType = WebsiteBlockTextAndMediaType.Default;
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.TextAndMedia;

    constructor(initializer?: Partial<Omit<WebsiteBlockTextAndMediaDisplayItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockTextAndMediaDisplayItem";
}
